// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__2bnyn","Highlighted":"Tag_Highlighted___WMmR","IconClose":"Tag_IconClose__1Cnw8"};